import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionButton = ({ icon, label, onClick, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card hover:bg-muted border-border',
    accent: 'bg-accent/10 hover:bg-accent/20 border-accent/30 text-accent',
    success: 'bg-success/10 hover:bg-success/20 border-success/30 text-success'
  };

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all duration-200 hover:scale-105 ${variantStyles?.[variant]}`}
    >
      <Icon name={icon} size={16} />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
};

export default QuickActionButton;